import React, { Component } from 'react';
import { updateEULA, updateCountry, SaveCurrentSession, addSession, changeSession, deleteSession, updateSession, loadSessionfromSSET,loadNotifications, fetchLookupServersList, GetWorkloadWithMainstream } from '../../State/actions/sessions';
import { logOut } from '../../State/actions/authentication';
import { connect } from 'react-redux';
import { said, appUrl, title, basename ,serviceUrl} from '../../AppConfig';
import queryString from 'query-string'
import RadioButton from 'grommet/components/RadioButton';
import Footer from 'grommet/components/Footer';
import Form from 'grommet/components/Form';
import Heading from 'grommet/components/Heading';
import Menu from 'grommet/components/Menu';
import Anchor from 'grommet/components/Anchor';
import Label from 'grommet/components/Label';
import Box from 'grommet/components/Box';
import Button from 'grommet/components/Button';
import Paragraph from 'grommet/components/Paragraph';
import List from 'grommet/components/List';
import ListItem from 'grommet/components/ListItem';
import Table from 'grommet/components/Table';
import TableRow from 'grommet/components/TableRow';
import Layer from 'grommet/components/Layer';
import TextInput from 'grommet/components/TextInput';

import Map from 'grommet/components/icons/base/Map';
import NewIcon from 'grommet/components/icons/base/New';
import User from 'grommet/components/icons/base/User';
import Info from 'grommet/components/icons/base/Info';
import LinkIcon from 'grommet/components/icons/base/Link';
import DocumentConfig from 'grommet/components/icons/base/DocumentConfig';
import ObjectUngroup from 'grommet/components/icons/base/ObjectUngroup';
import DownloadImg from 'grommet/components/icons/base/DocumentUser';
//import WorkshopIcon from 'grommet/components/icons/base/Workshop';
import Catalog from 'grommet/components/icons/base/Catalog';
import CloseIcon from 'grommet/components/icons/base/Close';
import WarningIcon from 'grommet/components/icons/base/Alert';
import TrashIcon from 'grommet/components/icons/base/FormTrash';
import FormNextLink from 'grommet/components/icons/base/FormNextLink';
import FormEdit from 'grommet/components/icons/base/FormEdit';
//import Select from 'grommet/components/Select';
import SVGIcon from 'grommet/components/icons/base/FormNextLink';
//import CustomFooter from './CustomFooter';
import LoadFiles from './LoadFiles';
import Notifications from './Notifications';
//import WhatsNewPage from '../../SizerUI/SizerScreens/WhatsNew';
import WhatsNewPage from './WhatsNew';
import UserDetailsPage from './UserDetails';


import { version } from '../../AppConfig';
import $ from 'jquery';
import { interviewScreens } from '../../SizerScreens';
import createBrowserHistory from 'history/createBrowserHistory';
import AdditionalReferenceComponent from '../../SizerHome/ReferenceArchitecture';
import ReferenceComponent from '../../SizerUI/SizerScreens/ReferenceArchitecture';
//import SAPLOOKUP from '../.././SizerUI/./SizerScreens/SAPLOOKUP';
import SAPLOOKUP from './SAPLOOKUP';
import NoteIcon from 'grommet/components/icons/base/Note';
import CircleQuestionIcon from 'grommet/components/icons/base/CircleQuestion';

//Commenting the below importas this is applicable only for cs750 and declearing again
//import { SIZING_MODES } from '../../SizerUI/Redux/reducers/sizerWorkload';

var SIZING_MODES = ['CS750Sizing', 'SynergySizing', 'vSANSizing', 'VDISizing', 'OCPSizing' ];
const history = createBrowserHistory();
let AdditionalList = '';
var TotalCountyNames = [];
let CountyList = [];
//let About = [];
let EPASizingHomeMenuItems;
let Screens = [];
function CreateGuid() {
  function _p8(s) {
    var p = (Math.random().toString(16) + "000000000").substr(2, 8);
    return s ? "-" + p.substr(0, 4) + "-" + p.substr(4, 4) : p;
  }
  return _p8().toUpperCase() + _p8().toUpperCase() + _p8().toUpperCase() + _p8().toUpperCase();
}
var DisagreeScreen ='';
const HPECP_SIZER = ("EzmeralCPSizer").toUpperCase();
const HPECP_HOMEPAGE_CONTENT = "Build a HPE Ezmeral Runtime Enterprise Solution";
let ssetURL ='';
let hideforSSET='False';
class MyMain extends Component {

  constructor() {
    super();
    this.state = {
      ProfileInformation: {
        "Name": '',
        "Email": '',
        "Country": ''
      },
      WhatsnewJson: '',
      referenceArchitectureState: false,
      OtherReferalSites: false,
      whatsNew: false,
      HowTo: false,
      About: false,
      UserGuide: false,
      LoadItemTitle: '',
      LoadPopupScr: false,
      AdditionalInfoPop: false,
      HomePageJson: '',
      CountyName: TotalCountyNames,
      EULAInformation: false,
      selectedCountry: 'United States',
      ShowCountryChangeAlert: false,
      Change_Session: '',

      showUpdateSession: false,
      showDelSession: false,
      SessionName: {},
      DelSession: {},
      SessionNameTxt: '',
      SAPLookuplayer: false,
      modeSelected: 'CS750',
      notifications:[],
      userClosedNotifications:false,
      agreeDisagreeClicked:false
    }

    this.closePopUps = this.closePopUps.bind(this);
    this.WhatsNewParent = this.WhatsNewParent.bind(this);
    this.AboutClick = this.AboutClick.bind(this);
    this.UserGuideClick = this.UserGuideClick.bind(this);
    this.WhatsNewClick = this.WhatsNewClick.bind(this);
    this.HowToClick = this.HowToClick.bind(this);
    this.UserDetailsClick = this.UserDetailsClick.bind(this);
    this.AdditionalInfo = this.AdditionalInfo.bind(this);
    this.LoadWorkloadPopupClick = this.LoadWorkloadPopupClick.bind(this);
    this.LoadSolutionPopupClick = this.LoadSolutionPopupClick.bind(this);
    this.getNewRoute = this.getNewRoute.bind(this);
    this.EULAInformationPopUpClose = this.EULAInformationPopUpClose.bind(this);
    this.ShowDelSession = this.ShowDelSession.bind(this);
    this.CloseDelSession = this.CloseDelSession.bind(this);
    this.SessionTxtChange = this.SessionTxtChange.bind(this);
    this.Submit_Update_Session = this.Submit_Update_Session.bind(this);
    this.Submit_Change_Session = this.Submit_Change_Session.bind(this);
    this.Submit_Delete_Session = this.Submit_Delete_Session.bind(this);
    this.ReferernceArchitecture = this.ReferernceArchitecture.bind(this);
    this.udateScreens = this.udateScreens.bind(this);
    this.onSizingModeChange = this.onSizingModeChange.bind(this);
    this.onSAPLookupClick = this.onSAPLookupClick.bind(this);
    this.BuildSolutionEvents = this.BuildSolutionEvents.bind(this);
    this.getTile=this.getTile.bind(this);
    this.closeNotifications = this.closeNotifications.bind(this);
    this.DisagreeClicked = this.DisagreeClicked.bind(this);
    this.yesorCancelClicked = this.yesorCancelClicked.bind(this);
    this.updateValue= this.updateValue.bind(this);

  }
  closeNotifications()
  {
    this.props.showNotifications.enabled=false;
    this.setState({userClosedNotifications:true});
  }
  onSAPLookupClick() {
    this.setState({ SAPLookuplayer: true, LoadPopupScr: false, AdditionalInfoPop: false, whatsNew: false, HowTo: false, About: false });
  }

  ReferernceArchitecture() {

    this.setState({ referenceArchitectureState: true });

  }
  componentDidMount() {
    Screens = interviewScreens;
    this.state.RouteObj = interviewScreens;

    var queryParameter = queryString.parse(this.props.location.search);
    var userData = {
      "reference": queryParameter.reference,
      "isSizerAsEntry":queryParameter.isSizerAsEntry? true:false};
    if (userData.reference != undefined && !this.props.sset) {
      this.setState({ EULAInformation: false });
      this.props.onLoadSessionfromSSET(userData);
      if (! queryParameter.isSizerAsEntry) {
    	  this.props.updateSSETId(queryParameter.reference);
      }
      if(this.props.guiState!==undefined){
        this.props.guiState.isSizerAsEntry = queryParameter.isSizerAsEntry?"True":"False";
      }
      if(queryParameter.reviewed)
      {
        this.props.sessionsState.ssetConfigurations.reviewed=true;
      }
      if(queryParameter.uInfo)
      {
        this.props.sessionsState.ssetConfigurations.uInfo=queryParameter.uInfo;
      }      
    }
    else {
        if(this.props.guiState!==undefined){
        this.props.guiState.isSizerAsEntry = queryParameter.isSizerAsEntry?"True":"False";
      }
      this.setState({ EULAInformation: this.props.EULAInformation });
    if(this.props.notifications==null)
    {
      userData = {
      "UserId": this.props.userData.email,      
      //"UserId": "test@hpe.com",      
      //"SizerId": "SAPSizer"
      "SizerId": said
    };
      this.props.onLoadNotifications(userData);
      //this.props.onLoadNotifications(this.props.userData.email);       
    }
    }
    if (this.props.sizerState && !this.props.sizerState.LookupServers) {
      this.props.OnFetchLookupServersList(this.props.country);
  }
  try{
  if(ssetURL===''){
   if(queryParameter.reference!==undefined)
    hideforSSET = 'True';
    else
    hideforSSET= 'False';
      this.getSSETURL();
  }
  }catch(e){}
    // if (said === 'SAPHANA') {
    //   this.props.onUpdateDefaultSession(this.props.DefaultInputs);
    // }

    //this.setState({ EULAInformation: 'false' });


    // if(this.state.HomePageJson.Sizers.Sizer["ProfileInformation"] ==undefined){
    // }
    // this.state.HomePageJson = HomeInformation;
    // console.log(this.state.HomePageJson);
    //   console.log(this.props.DefaultInputs);
    // this.setState({HomePageJson: this.props.DefaultInputs});
    //  console.log(this.state.HomePageJson);

  }
  componentWillReceiveProps(nextProps) {

if(nextProps.notifications != this.props.notifications)
{
var data = nextProps.notifications;
if(data.length === 0)
{
   this.props.showNotifications.enabled=false;
}
else{
  this.props.showNotifications.enabled=true;
}
this.setState({notifications:data});


}
    if (nextProps.activeSession !== "") {
      if (nextProps.activeSession.id !== "") {
        if (nextProps.activeSession.id !== this.props.activeSession.id) {
          if (nextProps.activeSession.treeView !== '') {
            let obj = "";
            if (said === 'CS750VirtSizer' ||  said === 'SynergySizer') {
              obj = {
                "Workload": nextProps.activeSession.workload
              }
            }
            else {
              obj = nextProps.activeSession.workload;
            }
            this.props.onNewSession(obj);
            //this.props.redirectTo('/Build/SolnAlternative');
            this.props.history.push('/Build/SolnAlternative');
          } else {
            let obj = "";
            if (said === 'CS750VirtSizer' ||  said === 'SynergySizer') {
              obj = {
                "Workload": nextProps.activeSession.workload
              }

              // this.props.guiState.SizingMode = nextProps.activeSession.workload.UserInputs.SizerMode;

            }
            else {
              obj = nextProps.activeSession.workload;
            }
            this.props.onUpdateDefaultSession(this.props.DefaultInputs);
            this.props.onNewSession(obj);
            let redirectionPath = '';

            if (said === 'EPAvNext' || said === 'SAPHANA') {
            var specificPages = interviewScreens.filter((route, id) => {
              if (route.type === nextProps.activeSession.workload.UserInputs.Environments.WorkloadType) {
                return route;
              }
            });
            redirectionPath = specificPages[0].path;
            this.getNewRoute(redirectionPath);
          }
          else{
            if (said === 'CS750VirtSizer') 
            redirectionPath = obj.Workload.UserInputs.isSized==='True' ?  Screens[1].path : Screens[0].path; 
            else redirectionPath = Screens[0].path;           
            this.getNewRoute(redirectionPath);
          }
            // this.props.history.push('/Build/ContactInfo');
          }
        }
      }
    }
  }

  ShowDelSession(delItem) {
    this.setState({ showDelSession: true, DelSession: delItem });
  }

  udateScreens(said, choice) {
    var temp = [];
    switch (said) {
      case 'SAPHANA': temp = Screens; break;
    }
  }

  CloseDelSession() {
    this.setState({ showDelSession: false, SessionName: {}, DelSession: {}, showUpdateSession: false });
  }
  WhatsNewParent() {
    this.closePopUps();
  }
  EULAInformationPopUpClose() {
    // this.props.EULAInformation = false;
    this.props.onUpdateEULA(false)
    this.setState({ EULAInformation: false });
  }

  Submit_Delete_Session(SessionID) {
    // if(this.props.GlobalErr !='' && this.props.GlobalErr.isError){
    //   this.setState({ErrorPopup: true, ErrorPopupMsg: this.props.GlobalErr.errorMsg});
    // }else{
    this.props.onDeleteSession(SessionID);
    this.CloseDelSession();
    // }
  }

  getSSETURL(){
    let tokenUrl = 'SizingEngine/GetconfigDetails';
    let type = 'urlToken';
    console.log(serviceUrl);
    let url = serviceUrl+tokenUrl;
    this.fetchSSETURL(url,type).then((result)=>{
      console.log(result);
      try{
      ssetURL = result.redirectToken;
      window.sessionStorage.setItem("ssetURL",result.redirectToken);
      }catch(e){}
    })
  }
  fetchSSETURL(url,type){
    return new Promise((resolve,reject)=>{
      fetch(url,{
        method:'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Cache': 'no-cache'
        },
        credentials: 'same-origin'
      }).then(function(response){
        console.log(response);
        if(!response.ok){
          throw Error(response.statusText)
        }if (type === 'urlToken') {
          let data = {};
          data.redirectToken = response.headers.get('redirectToken');
          data.continuetoSSETToken = response.headers.get('continueRedirectToken');
          resolve(data);
        }
        return response.json();
      })
    })
  }
  updateValue(){
    //console.log('insideupdatevalue',ssetURL);
    this.setState({});
  }





  Submit_Change_Session(SessionID) {
    // if(this.props.GlobalErr !='' && this.props.GlobalErr.isError){
    //   this.setState({ErrorPopup: true, ErrorPopupMsg: this.props.GlobalErr.errorMsg});
    // }else{
    //   var errorObj = { isError:false, errorMsg:''};
    //   this.props.updateError(errorObj);

    var CurrentCountry = this.props.country;
    // this.props.onUpdateActiveSession(this.props.sizerWorkLoad);
    // this.props.onSaveCurrentSession();
    this.props.onChangeSession(SessionID);

    var workload = '';
    this.props.allSessions.map((value, index) => {
      if (value.id === SessionID)
        workload = value.workload;
    })

    this.props.onNewSession(workload);

    this.props.allSessions.filter((sessionItem, index) => {
      if (sessionItem.id === SessionID) {
        if (sessionItem.treeView !== '') {

          if (CurrentCountry === sessionItem.treeView.Solutions['@Country']) {
            this.props.history.push('/Build/SolnAlternative');
            $('#footer').show()

          } else {
            this.setState({ ShowCountryChangeAlert: true, Change_Session: sessionItem });
            $('#footer').show()
          }
        } else {
          if (said === 'EPAvNext' || said === 'SAPHANA') {
            var specificPages = this.state.RouteObj.filter((route, id) => {
              if (route.type === sessionItem.workload.UserInputs.Environments.WorkloadType) {
                return route;
              }

            });
            this.props.history.push(specificPages[0]['path']);
          }
          else {
            this.props.history.push(this.state.RouteObj[0]['path']);
          }
          $('#footer').hide()
        }
      }
    });
    // if(this.props.activeSession.treeView !== ''){
    //   this.props.history.push('/Build/SolnAlternative');
    // }else{
    //   // this.props.history.push('/Build/ContactInfo');
    //   this.props.history.push(this.state.RouteObj[0]['path']);
    // }
    // }
  }

  onSizingModeChange(e) {
    this.setState({ modeSelected: e.target.value });
    this.props.guiState.SizingMode = e.target.value;

  }
  Submit_Update_Session() {
    if (this.state.SessionNameTxt.trim() !== '') {
      this.state.SessionName.alias = this.state.SessionNameTxt;
      this.props.onSaveCurrentSession();
      this.props.onUpdateSession(this.state.SessionName);
      if (this.props.activeSession.id === this.state.SessionName.id) {
        this.props.onChangeSession(this.props.activeSession.id);
      }
      this.setState({ showDelSession: false, showUpdateSession: false, SessionName: {}, DelSession: '' });
    }
  }

  SessionTxtChange(e) {
    if (e.target.value.length <= 25) {
      this.setState({ SessionNameTxt: e.target.value });
    }
  }

  onSelCountry(e) {
    var obj = this.state.ProfileInformation;
    obj.Country = e.target.innerHTML.trim();

    this.props.onCountryChange(obj.Country);

    this.setState({
      //selectedCountry: obj.Country,
      ProfileInformation: obj,
      HowTo: false, whatsNew: false, About: false, AdditionalInfoPop: false
    });
  }

  closePopUps() {
    this.setState({
      LoadItemTitle: '', LoadPopupScr: false,
      HowTo: false, whatsNew: false, About: false, AdditionalInfoPop: false, referenceArchitectureState: false,
      userDetailsPop: false, SAPLookuplayer: false, UserGuide: false
    })
  }

  AdditionalInfo() {
    this.setState({ HowTo: false, whatsNew: false, About: false, AdditionalInfoPop: true, userDetailsPop: false, });
  }

  AboutClick() {
    this.setState({ About: true, HowTo: false, whatsNew: false, userDetailsPop: false, UserGuide: false });
  }
  UserGuideClick() {
    this.setState({ About: false, HowTo: false, whatsNew: false, userDetailsPop: false, UserGuide: true });
  }

  WhatsNewClick() {
    this.setState({ AdditionalInfoPop: false, whatsNew: true, HowTo: false, About: false, userDetailsPop: false });
  }

  UserDetailsClick() {
    this.setState({ AdditionalInfoPop: false, whatsNew: false, HowTo: false, About: false, userDetailsPop: true });
  }

  HowToClick() {
    this.setState({ HowTo: false, whatsNew: false, About: false, userDetailsPop: false });
  }

  getNewRoute(str) {
    this.closePopUps();
    this.props.history.push(str);
  }

  LoadWorkloadPopupClick() {
    if (said === 'SAP') {
      // this.props.onNewSession(this.props.workloadTemplate);
      this.props.onUpdateDefaultSession(this.props.DefaultInputs);
    }
    this.setState({ LoadItemTitle: 'Workload', LoadPopupScr: true, AdditionalInfoPop: false, whatsNew: false, HowTo: false, About: false });
  }

  LoadSolutionPopupClick() {
    // loadData = this.props.onLoadSolution('', '');
    this.setState({ LoadItemTitle: 'Solution', LoadPopupScr: true, AdditionalInfoPop: false, whatsNew: false, HowTo: false, About: false });
  }

DisagreeClicked(){
  this.EULAInformationPopUpClose();
  this.setState({agreeDisagreeClicked:true });
  
}
yesorCancelClicked(e){
 DisagreeScreen='';
 this.closePopUps();
 this.setState({ EULAInformation: true, agreeDisagreeClicked:false });
 if(e.target.id==='btnYes'){ 
   //window.open(appUrl,'_self');
   //window.open(window.location.protocol+'//'+window.location.host,'_self')
   if(window.sessionStorage.getItem("IsParent")==="True"){
    window.open(window.location.protocol+'//'+window.location.host,'_self')
  }else{
   window.top.close();
  }
 }
}
  

  BuildSolutionEvents()
  {
    this.udateScreens();
                  console.log(Screens);
                  $('#footer').hide();
                  this.props.onUpdateActiveSession(this.props.sizerWorkLoad);
                  this.props.onSaveCurrentSession();
                  this.props.onAddSession(CreateGuid(), 'Default Session');
                  // this.props.history.push('/Build/ContactInfo');
                  this.props.history.push(Screens[0]['path']);
                  if (said === 'SAPHANA' || said === 'EPA' || said === 'SAP') {
                    this.props.onNewSession(this.props.workloadTemplate);
                    this.props.onUpdateDefaultSession(this.props.DefaultInputs);
                  }
                  else if (said === 'CS750VirtSizer' ||  said === 'SynergySizer') {
                    this.props.guiState.isValueChanged = false;
                    this.props.guiState.isNoPreferenceStorage = 'False';
                    if (this.props.allSessions.length > 0) {
                      var obj = {
                        "Workload": this.props.workloadTemplate
                      }
                      obj.Workload.UserInputs.SizerMode = this.props.guiState.SizingMode;
                      this.props.onNewSession(obj);
                    }
                  }
  }

  getTile(title,method,text,btnText,mode)
  {
    return  <Box>
              <Heading seperator='bottom' tag='h4' strong={true} style={{ color: '#2ad2c9',marginBottom:'0px' }}> {title}</Heading>
              <Paragraph size='small' className='customclass'>              
                {text}</Paragraph> {title==='General Purpose Sizing' ? <br/> :''}
              <Box style={{border:'2px solid #01a982', backgroundColor:'#01a982',width:'60%',alignItems:'center'}} >
              <Anchor icon={<SVGIcon style={{stroke:'white'}}/>} style={{ fontSize: '17px',margin:'2px',color:'white',fontWeight:'500' }}
                label={btnText}
                onClick={()=>{
                  if(mode!==undefined)
                  {
                     this.props.guiState.SizingMode = mode;
                     this.setState({ modeSelected: mode });                     
                  }
                  method();
                }}  
                primary={true}
                reverse={true} />
                </Box>
                </Box>
  }

  buildAdditionalSolution = (type)=>
  {
    this.props.onUpdateActiveSession(this.props.sizerWorkLoad);
    this.props.onSaveCurrentSession();
    this.props.onAddSession(CreateGuid(), 'Default Session');
    var temp = type;
    var specificPages = this.state.RouteObj.filter((route, id) => {
      if (route.type === undefined)
        return route;
      else {
        if (said === 'EPAvNext' || said==='SAPHANA') {
          if (route.type === temp) {
            return route;
          }
        }
      }
    });

    this.props.history.push(specificPages[0]['path']);    
    this.props.onNewSession(this.props.blueDataworkloadTemplate);
    this.props.onUpdateDefaultSession(this.props.DefaultInputs);
  }

  render() {

    //About = null;
    let whatsnewButton;
    if (this.props.WhatsNewContent !== undefined && this.props.WhatsNewContent !== '') {
      this.state.WhatsnewJson = this.props.WhatsNewContent;

      whatsnewButton = <Anchor className='active WeightFontColor' onClick={this.WhatsNewClick} label="What's New" icon={<NewIcon colorIndex="#ff8d6d" size="small" />} />
    }

    let userDetails;
    if (this.props.userData !== undefined
      && this.props.userData.username != undefined //){
      && this.props.userData.email !== "default@test.com"
      && this.props.userData.username !== "default") {
      userDetails =
        <Box>
          <Anchor className='active WeightFontColor' onClick={this.UserDetailsClick} label={'Hello ' + this.props.userData.username} icon={<User colorIndex="#ff8d6d" size="small" />} />
        </Box>
    }
    let SizerCaption;
    if (this.props.DefaultInputs !== undefined && this.props.DefaultInputs !== '') {
      SizerCaption = this.props.DefaultInputs["Sizers"]["SizerCaption"]

      // if(basename.indexOf('GeneralPurposeSizer') !== -1)
      // {
      //   //this.state.HomePageJson.Sizers.Sizer.SizerCaption='General Purpose Sizer';
      //   SizerCaption = 'HPE Sizer for Synergy Infrastructure';
      // }
      var docName = SizerCaption;
      var UserGuide = " UserGuide";

      switch (said) {
        case 'EPAvNext': docName = 'HPE Sizing Tool for EPA '; break;
      }

      this.state.HomePageJson = this.props.DefaultInputs;      
      
      if (TotalCountyNames.length == 0) {
        this.props.countries.Countries.Country.map((val) => {
          TotalCountyNames.push(val["Name"]);
        });
      }

      CountyList = TotalCountyNames.map(function (selCountry, index) {
        return (<Anchor key={index} onClick={this.onSelCountry.bind(this)}> {selCountry} </Anchor>);
      }.bind(this));
      //About = this.props.DefaultInputs.Sizers.Sizer.About.Para1


      /* display menu content dynamically stats here*/
      let that = this;
      var style={
            //backgroundColor:'rgba(66, 85, 99, 0.54)',
            padding:'10px',  width:'33%', borderTop:'3px solid #2ad2c9'
        }
     //basename.indexOf('GeneralPurposeSizer') === -1 ?
      if (said === "EPAvNext") {
        UserGuide = " User Guide"
        var defaultsIndex;
        if (appUrl.toUpperCase().indexOf(HPECP_SIZER) > -1) {
          defaultsIndex = this.props.DefaultInputs.Sizers.Sizer.Index.Sections.Section.findIndex(x => x["@Title"] === "Build BigData Solution");
          this.props.DefaultInputs["Sizers"]["SizerCaption"] = title;
          docName = 'EPA HPE Ezmeral Runtime Enterprise Sizer Online -';
        } else {
          defaultsIndex = this.props.DefaultInputs.Sizers.Sizer.Index.Sections.Section.findIndex(x => x["@Title"] === HPECP_HOMEPAGE_CONTENT);
          docName = 'EPA BigData Sizer Online -';
        }
        if (defaultsIndex >= 0) {
          this.props.DefaultInputs.Sizers.Sizer.Index.Sections.Section.splice(defaultsIndex, 1);
        }
      } 
      said !=='SynergySizer' ?
      EPASizingHomeMenuItems = this.props.DefaultInputs.Sizers.Sizer.Index.Sections.Section.map((item) => {
        var SpaceforLoad = 'start'
        var ChooseRadiobutton;
        var onClickAction;
        var TitleIcon;
        var titleTag = item["@Title"]
        switch (titleTag) {
          case 'Load Previously Saved Solution':
            SpaceforLoad = 'center';
            onClickAction = this.LoadSolutionPopupClick;
            TitleIcon = <Info size="large" colorIndex="accent-1" />
            break;
          case 'Load Solution':
            SpaceforLoad = 'center';
            onClickAction = this.LoadSolutionPopupClick;
            TitleIcon = <Info size="large" colorIndex="accent-1" />
            break;
          case 'Load Previously Saved Workload':
            SpaceforLoad = 'center'
            onClickAction = this.LoadWorkloadPopupClick;
            TitleIcon = <DocumentConfig size="large" colorIndex="accent-1" />
            break;
          case 'Load Workload':
            SpaceforLoad = 'center'
            onClickAction = this.LoadWorkloadPopupClick;
            TitleIcon = <DocumentConfig size="large" colorIndex="accent-1" />
            break;

          case 'Build a New Solution':
            TitleIcon = <ObjectUngroup size="large" colorIndex="accent-1" />
            onClickAction = () => {
              this.BuildSolutionEvents();
            }
            break;
          case 'Build Solution':
            TitleIcon = <ObjectUngroup size="large" colorIndex="accent-1" />
            onClickAction = () => {
              this.udateScreens();
              console.log(Screens);
              $('#footer').hide();
              this.props.onUpdateActiveSession(this.props.sizerWorkLoad);
              this.props.onSaveCurrentSession();
              this.props.onAddSession(CreateGuid(), 'Default Session');
              // this.props.history.push('/Build/ContactInfo');
              this.props.history.push(Screens[0]['path']);
              if (said === 'EPA' || said === 'SAP') {
                this.props.onNewSession(this.props.workloadTemplate);
                this.props.onUpdateDefaultSession(this.props.DefaultInputs);
              }
              else if (said === 'CS750VirtSizer'||  said === 'SynergySizer') {
                if (this.props.allSessions.length > 0) {
                  var obj = {
                    "Workload": this.props.workloadTemplate
                  }
                  obj.Workload.UserInputs.SizerMode = this.props.guiState.SizingMode;
                  this.props.onNewSession(obj);
                }
              }
            }
            break;
            case 'Build SAP Appliance Solution':
              TitleIcon = <ObjectUngroup size="large" colorIndex="accent-1" />
              onClickAction = () => {
                this.udateScreens();
                console.log(Screens);
                $('#footer').hide();
                this.props.onUpdateActiveSession(this.props.sizerWorkLoad);
                this.props.onSaveCurrentSession();
                this.props.onAddSession(CreateGuid(), 'Default Session');
                // this.props.history.push('/Build/ContactInfo');
                this.props.history.push(Screens[0]['path']);
                if (said === 'SAPHANA') {
                  this.props.onNewSession(this.props.workloadTemplate);
                 // this.props.onUpdateDefaultSession(this.props.DefaultInputs);
                  this.props.GetWorkloadWithMainstream(this.props.country);
                }
              }
              break;

          case 'Build BigData Solution':
            TitleIcon = <ObjectUngroup size="large" colorIndex="accent-1" />
            onClickAction = () => {
              $('#footer').hide();
              //this.props.onblueorbigUpdate("BigData")
              this.props.onUpdateActiveSession(this.props.sizerWorkLoad);
              this.props.onSaveCurrentSession();
              this.props.onAddSession(CreateGuid(), 'Default Session');
              this.props.history.push(this.state.RouteObj[0]['path']);
              this.props.onNewSession(this.props.workloadTemplate);
              this.props.onUpdateDefaultSession(this.props.DefaultInputs);
            }
            break;

          case HPECP_HOMEPAGE_CONTENT:
            TitleIcon = <ObjectUngroup size="large" colorIndex="accent-1" />
            onClickAction = () => {
              $('#footer').hide();
              // this.props.onblueorbigUpdate("BlueData")
              this.props.onUpdateActiveSession(this.props.sizerWorkLoad);
              this.props.onSaveCurrentSession();
              this.props.onAddSession(CreateGuid(), 'Default Session');
              var temp = 'BlueData';
              var specificPages = this.state.RouteObj.filter((route, id) => {
                if (route.type === undefined)
                  return route;
                else {
                  if (said === 'EPAvNext') {
                    if (route.type === temp) {
                      return route;
                    }
                  }
                }
              });

              this.props.history.push(specificPages[0]['path']);
              this.props.onNewSession(this.props.blueDataworkloadTemplate);
              this.props.onUpdateDefaultSession(this.props.DefaultInputs);
            }
            break;

          case 'Build SAP TDI Solution':
              TitleIcon = <ObjectUngroup size="large" colorIndex="accent-1" />
              onClickAction = () => {
                $('#footer').hide();
                // this.props.onblueorbigUpdate("BlueData")
                this.buildAdditionalSolution('TDI');
              }

              break;
              
              case "SAPS Lookup":
                // SpaceforLoad='center';
                TitleIcon = <NoteIcon size="large" colorIndex="accent-1" />
                onClickAction = this.onSAPLookupClick;
                break

          case 'Choose Server Type':
            TitleIcon = <LinkIcon size="large" colorIndex="accent-1" />
            //ChooseRadiobutton = <RadioButton checked="true" className="SynergychooseRadiobtn" />
            //   ChooseRadiobutton = <Select inline={true} value={that.props.guiState.SizingMode} options={SIZING_MODES} onChange={this.onSizingModeChange} />
            ChooseRadiobutton = <Box style={{ marginLeft: '7px' }} >
              <Box direction='row' style={{ marginLeft: '10%' }}>
                <RadioButton value={SIZING_MODES[0]} checked={that.props.guiState.SizingMode === "CS750Sizing" ? true : false} className='RdioBtnName' style={{ color: 'white' }} id='CS750' label='CS750Sizing' onChange={this.onSizingModeChange} />
                <RadioButton value={SIZING_MODES[1]} checked={that.props.guiState.SizingMode === "SynergySizing" ? true : false} className='RdioBtnName' id='ESXi' label='SynergySizing' onChange={this.onSizingModeChange} />
              </Box>
              <Box direction='row' style={{ marginTop: '18px' }}>
                <Box >
                  <RadioButton value={SIZING_MODES[2]} checked={that.props.guiState.SizingMode === "vSANSizing" ? true : false} className='RdioBtnName' id='vSAN' label='vSANSizing' onChange={this.onSizingModeChange} />
                </Box >
                <Box style={{ marginLeft: '7px' }}>
                  <RadioButton value={SIZING_MODES[3]} checked={that.props.guiState.SizingMode === "VDISizing" ? true : false} className='RdioBtnName' id='VDI' label='VDISizing' onChange={this.onSizingModeChange} />
                </Box >
                <Box style={{ marginLeft: '7px' }}>{/* radio btn for entering OcpSizing screens. added by aditya */}
                  <RadioButton value={SIZING_MODES[4]} checked={that.props.guiState.SizingMode === "OCPSizing" ? true : false} className='RdioBtnName' id='RedHat' label='OCPSizing' onChange={this.onSizingModeChange} />
                </Box >
              </Box>
            </Box>
            break;

          case 'View Preconfigured Systems':
            break;

          case ' Build your own solutions':
            break;

          case 'Reference Architecture':
            onClickAction = this.ReferernceArchitecture;
            this.props.onUpdateDefaultSession(this.props.DefaultInputs);
            TitleIcon = <LinkIcon size="large" colorIndex="accent-1" />
            break;

          case 'Additional Information':
            onClickAction = this.AdditionalInfo;
            TitleIcon = <LinkIcon size="large" colorIndex="accent-1" />
            break;

          default:

        }


        if (item["@Title"] == "   Check for a Newer Version") {

        } else if (item["@Title"] == "   View Preconfigured Systems") {

        } else if (item["@Title"] == "   Let us build one for you") {

        } else if (item["Text"] == "Customer Information") {
        } else if (item["Text"] == "Company Name") {
        } else if (item["Text"] == "Project Name") {
        } else if (item["Text"] == "Project Contact Person e-Mail") {
        } else if (item["Text"] == "SAPS Lookup") {
          onClickAction = this.onSAPLookupClick;
        } else if (item["Text"] == "Use SAPS Lookup table to view the SAP value of a specific server model.") {
        }

        else {
          let text_ = item["Text"] 
          if (item["@Title"] === 'Reference Architecture') {
            if (appUrl.toUpperCase().indexOf(HPECP_SIZER) !== -1) {
              text_ = item["Text"].replace('EPA', 'HPE Ezmeral Runtime Enterprise');
            }
          }
          return (
            <Box margin="small" onClick={onClickAction} key={titleTag} className="onHoverTab" align='center' wrap={true} pad='small' basis="medium">
              <Box direction='row'>
                <Anchor>
                  {TitleIcon}
                </Anchor>
              </Box>
              <Heading tag="h3" align="center" strong={true} style={{ color: '#fff' }}>{item["@Title"]}</Heading>
              <Box direction='row' alignContent="center" align="center" style={{ width: '100%' }}>
                <Paragraph margin="none" style={{ color: '#fff', textAlign: SpaceforLoad, width: '100%' }}>
                  {ChooseRadiobutton}  {item['@Title'] === 'Choose Server Type' ? '' : text_}
                </Paragraph>
              </Box>
            </Box>
          );
        }

          }) : EPASizingHomeMenuItems = <Box style={{width: '100%'}}>
          <Box direction='row' style={{ alignItems: 'center', width: '100%',marginTop:'20px' }}  >             
            <Box style={{padding:'10px 10px 10px 0px',  width:'33%', borderTop:'3px solid #2ad2c9'}} >            
            {this.getTile('General Purpose Sizing', this.BuildSolutionEvents,'This option allows you to size a general purpose virtualized solution with VMware ESXi on the HPE Synergy hardware platform.','Build New Solution','SynergySizing')}
            </Box>
            <Box style={style} margin='small'>
            {this.getTile('vSAN Sizing',this.BuildSolutionEvents,'This option allows you to size a virtualized solution with VMware VCF or VSAN on the HPE Synergy hardware platform with vSAN certified compute, memory and storage.','Build New Solution','vSANSizing')}            
            </Box>
            <Box style={style} margin='small'>
             {this.getTile('VDI Sizing',this.BuildSolutionEvents,'This option allows you to size a VDI solution with Citrix XenServer or VMware ESXi on the HPE Synergy hardware platform with D3940, 3PAR StoreServ Storage/Nimble Storage.','Build New Solution','VDISizing')}                                       
            </Box>
          </Box>


          <Box direction='row' style={{ alignItems: 'center', width: '100%',marginTop:'20px' }} >             
            <Box style={{padding:'10px 10px 10px 0px',  width:'33%', borderTop:'3px solid #2ad2c9',paddingLeft:'0px !important'}} >
              {this.getTile('Load Previously Saved Solution', this.LoadSolutionPopupClick,' Click on this button to open up a previously saved completed solution including the Recommended Solution, Configuration Details, and Bill Of Materials (BOM).','Load Solution')}

              
            </Box>
            <Box style={style} margin='small'>
            {this.getTile('Load Previously Saved Workload', this.LoadWorkloadPopupClick,'  Click on this button to open up a previously saved workload so the workload data can be viewed or edited. This option is normally used to alter the data.','Load Workload')}

             
            </Box>            
          </Box>
          </Box>

      //Changes for Synergy Home page
      if (said === 'CS750VirtSizer' ||  said === 'SynergySizer') {
        // this.state.Sizercontentone = "The Synergy sizing tool is designed to assist users in identifying the HPE HW and SW needed to support a workload defined by the user. The tool will produce a general sizing BOM that can be used for budgetary quoting and as the foundation for creating live order quotes.After a detailed interview process, the HPE Sizer for ConvergedSystems Virtualization will generate a solution that details the hardware, software, and services best suited for the specific requirements. The resulting solution will include HPE Watson configuration guidance."

          this.state.Sizercontentone = "The Synergy sizing tool is designed to assist users in identifying the HPE HW and SW needed to support a workload defined by the user. The tool will produce a general sizing BOM that can be used for budgetary quoting and as the foundation for creating live order quotes.After a detailed interview process, the HPE Sizer for ConvergedSystems Virtualization will generate a solution that details the hardware, software, and services best suited for the specific requirements."

      }

    }
    /*Display menu content ends here */
    var Textcontent = '';
    if (said === 'CS750VirtSizer'||  said === 'SynergySizer') {
      Textcontent =<Box style={{width:'100%',alignItems:'center', marginTop: '20px'}}> <Box style={{width:'100%'}} justify='start' align='center' wrap={false} pad='none' margin='none'>
        <Paragraph className="TextcontentparagraphHome" >{this.state.Sizercontentone}</Paragraph>
      </Box></Box>
    }

    var WhatsnewHere;
    var AboutHere;
    var UserGuideHere;
    var HowToHere;
    var AdditionalInformation;
    var EULAInformationPopUp;
    var UserDetailsRender;
    if(/*(said === 'CS750VirtSizer') &&*/ this.state.agreeDisagreeClicked){
    DisagreeScreen=
            <Layer className="DisagreeLayer">
            <Form>
            <Box margin="none" pad="small" separator="bottom" style={{ backgroundColor: '#425563' }}>
            <Box direction="row" margin="none" pad="none" align='start'>
              <Heading tag="h4" style={{ marginBottom: '0px', color: '#fff' }}>{this.state.HomePageJson.Sizers!==undefined?this.state.HomePageJson.Sizers.SizerCaption:'HPE Sizer for ConvergedSystems Virtualization'}</Heading>
            </Box>
             </Box>
            <Box pad={{ "vertical": "small" }} align='center' textAlign='center' direction='row' style={{height:'100px'}}>
             <CircleQuestionIcon style={{ marginLeft: '10%' }} size="medium" colorIndex='#ff9374'/>
             <Label style={{ marginLeft: '2%' }}>Are you sure you wish to exit the application ?</Label>
            </Box>
           
            <Footer pad={{ "vertical": "small" }} separator="top" align='center' textAlign='center' direction='row'>
            <Button name='btnYes' id='btnYes' primary={true} style={{ marginLeft: '25%',width:'120px',height:'40px'}} onClick={this.yesorCancelClicked}>Yes</Button>
            <Button name='btnCancel' primary={true} style={{ marginLeft: '3%',width:'120px',height:'40px' }} onClick={this.yesorCancelClicked}>Cancel</Button>
            </Footer>
            </Form>
            </Layer>
    }
    if (this.state.EULAInformation) {
      EULAInformationPopUp = <Layer className="EULAPOPupLayer">
        <Form>
          <Box margin="none" pad="small" className="EULAcontentScroll" style={{ overflow: 'auto' }}>
            <Heading tag='h5' strong={true} uppercase={false} truncate={false} style={{ color: '#01a982' }}>
              PLEASE READ CAREFULLY:
                                            </Heading>
            <Paragraph margin="small">
              1.<b>Applicability.</b>
              This end user license agreement (the "Agreement")   governs the use of accompanying software, unless it is subject to a separate agreement between you  and Hewlett Packard Enterprise Company and its subsidiaries (“HPE”). By downloading, copying, or using the software   you agree to this Agreement. HPE provides translations of this Agreement in certain languages other than English, which may be found at:
                                                <a href="http://www.hpe.com/software/SWLicensing" target="_blank">http://www.hpe.com/software/SWLicensing</a>
            </Paragraph>
            <Paragraph margin="small">
              2.<b>Terms.</b>
              This Agreement includes supporting material accompanying the software or referenced by HPE,  which may be software license information, additional license authorizations, software specifications,  published warranties, supplier terms, open source software licenses and similar content (Supporting Material).  Additional license authorizations are at:
                                                <a href="http://www.hpe.com/software/SWLicensing" target="_blank">http://www.hpe.com/software/SWLicensing</a>
            </Paragraph>
            <Paragraph margin="small">
              3.<b>Authorization.</b>
              If you agree to this Agreement on behalf of another person or entity, you warrant you have authority to do so.
                                            </Paragraph>
            <Paragraph margin="small">
              4.<b>Consumer Rights.</b>
              If you obtained software as a consumer, nothing in this Agreement affects your statutory rights.
                                            </Paragraph>
            <Paragraph margin="small">
              5.<b>Electronic Delivery.</b>
              HPE may elect to deliver software and related software product or license information by electronic transmission or download.
                                            </Paragraph>
            <Paragraph margin="small">
              6.<b>License Grant.</b>
              If you abide by this Agreement, HPE grants you a non-exclusive non-transferable license to use one copy of the version or
                                                            release of the accompanying software for your internal purposes only, and is subject to any specific software licensing
                                                          information that is in the software product or its Supporting Material.
                                                          Your use is subject to the following restrictions, unless specifically allowed in Supporting Material:
                                                          <Paragraph className="EULAPOPupSubtexts">
                - You may not use software to provide services to third parties.
                                                          </Paragraph >
              - You may not make copies and distribute, resell or sublicense software to third parties.
                                                          <Paragraph className="EULAPOPupSubtexts">
                - You may not download and use patches, enhancements, bug fixes, or similar updates unless you have a license to the underlying software. However, such license doesn't automatically give you a right to receive such updates and HPE reserves the right to make such updates only available to customers with support contracts.
                                                          </Paragraph>
              - You may not copy software or make it available on a public or external distributed network.
                                                          <Paragraph className="EULAPOPupSubtexts">
                - You may not allow access on an intranet unless it is restricted to authorized users.
                                                          </Paragraph>
              - You may make one copy of the software for archival purposes or when it is an essential step in authorized use.
                                                          <Paragraph className="EULAPOPupSubtexts">
                - You may not modify, reverse engineer, disassemble, decrypt, decompile or make derivative works of software. If you have a mandatory right to do so under statute, you must inform HPE in writing about such modifications.
                                                          </Paragraph>
            </Paragraph>
            <Paragraph margin="small">
              7.<b>Remote Monitoring.</b>
              Some software may require keys or other technical protection measures and HPE may monitor your compliance with the Agreement, remotely or otherwise. If HPE makes a license management program for recording and reporting license usage information, you will use such program no later than 180 days from the date it's made available.
                                            </Paragraph>
            <Paragraph margin="small">
              8.<b>Ownership.</b>
              No transfer of ownership of any intellectual property will occur under this Agreement.
                                            </Paragraph>
            <Paragraph margin="small">
              9.<b>Copyright Notices.</b>
              You must reproduce copyright notices on software and documentation for authorized copies.
                                            </Paragraph>
            <Paragraph margin="small">
              10.<b>Operating Systems.</b>
              Operating system software may only be used on approved hardware and configurations.
                                            </Paragraph>
            <Paragraph margin="small">
              11.<b>90-day Limited Warranty for HPE Software.</b>
              - HPE-branded software materially conforms to its specifications, if any, and is free of malware at the time of delivery;
                                                              if you notify HPE within 90 days of delivery of non-conformance to this warranty, HPE will replace your copy.
                                                              This Agreement states all remedies for warranty claims.
                                                    <Paragraph className="EULAPOPupSubtexts">
                - HPE does not warrant that the operation of software will be uninterrupted or error free, or that software will operate in hardware
                                                              and software combinations other than as authorized by HPE in Supporting Material.
                                                              To the extent permitted by law, HPE disclaims all other warranties.
                                                    </Paragraph>
            </Paragraph >
            <Paragraph margin="small">
              12.<b>Intellectual Property Rights Infringement.</b>
              HPE will defend and/or settle any claims against you that allege that HPE-branded software as supplied under this Agreement infringes the intellectual property rights of a third party. HPE will rely on your prompt notification of the claim and cooperation   with our defense. HPE may modify the software so as to be non-infringing and materially equivalent, or we may procure a license.  If these options are not available, we will refund to you the amount paid for the affected product in the first year or the depreciated  value thereafter. HPE is not responsible for claims resulting from any unauthorized use of the software.
                                                    </Paragraph>
            <Paragraph margin="small">
              13.<b>Limitation of Liability.</b>
              HPE's liability to you under this Agreement is limited to the amount actually paid by you to HPE for the relevant software,
                                                              except for amounts in Section 12 ("Intellectual Property Rights Infringement").
                                                              Neither you nor HPE will be liable for lost revenues or profits, downtime costs, loss or damage to data or indirect,
                                                              special or consequential costs or damages. This provision does not limit either party's liability for:
                                                              unauthorized use of intellectual property, death or bodily injury caused by their negligence; acts of fraud; willful
                                                              repudiation of the Agreement; or any liability that may not be excluded or limited by applicable law.
                                                    </Paragraph>

            <Paragraph margin="small">
              14.<b>Termination.</b>
              This Agreement is effective until terminated or in the case of a limited-term license, upon expiration;
                                                            however, your rights under this Agreement terminate if you fail to comply with it.
                                                            Immediately upon termination or expiration, you will destroy the software and documentation and any copies, or return them to HPE.
                                                            You may keep one copy of software and documentation for archival purposes. We may ask you to certify in writing you have complied with
                                                            this section. Warranty disclaimers, the limitation of liability, this section on termination,
                                                            and Section 15 ("General") will survive termination.
                                                    </Paragraph>

            <Paragraph margin="small">
              15.<b>General.</b>
              a.<u>Assignment.</u>
              You may not assign this Agreement without prior written consent of HPE, payment of transfer fees and compliance with HPE's software
                                                                license transfer policies. Authorized assignments will terminate your license to the software and you must deliver software and
                                                                documentation and copies thereof to the assignee. The assignee will agree in writing to this Agreement. You may only transfer
                                                                firmware if you transfer associated hardware.
                                                          <Paragraph className="EULAPOPupSubtexts">

                b.<u>U.S. Government.</u>
                If the software is licensed to you for use in the performance of a U.S. Government prime contract or subcontract, you agree that,
                                                                    consistent with FAR 12.211 and 12.212, commercial computer software, computer software documentation and technical data for
                                                                    commercial items are licensed under HPE's standard commercial license.
                                                              </Paragraph>
              c.<u>Global Trade Compliance.</u>
              You agree to comply with the trade-related laws and regulations of the U.S. and other national governments. If you export,
                                                                    import or otherwise transfer products provided under this Agreement, you will be responsible for obtaining any required export or
                                                                    import authorizations. You confirm that you are not located in a country that is subject to trade control sanctions
                                                                    (currently Cuba, Iran, N. Korea, N. Sudan, and Syria) and further agree that you will not retransfer the products to any such country.
                                                                    HPE may suspend its performance under this Agreement to the extent required by laws applicable to either party.
                                                              <Paragraph className="EULAPOPupSubtexts">
                d.<u>Audit.</u>
                HPE may audit you for compliance with the software license terms. Upon reasonable notice, HPE may conduct an audit during
                                                                    normal business hours (with the auditor's costs being at HPE's expense). If an audit reveals underpayments then you will pay to
                                                                    HPE such underpayments. If underpayments discovered exceed five (5) percent, you will reimburse HPE for the auditor costs.
                                                              </Paragraph>
              e.<u>Open Source Components.</u>
              To the extent the Supporting Material includes open source licenses, such licenses shall control over this Agreement with
                                                                    respect to the particular open source component. To the extent Supporting Material includes the GNU General Public License or
                                                                    the GNU Lesser General Public License: (a) the software includes a copy of the source code; or (b) if you downloaded the
                                                                    software from a website, a copy of the source code is available on the same website; or (c) if you send HPE written notice,
                                                                    HPE will send you a copy of the source code for a reasonable fee.
                                                              <Paragraph className="EULAPOPupSubtexts">
                f.<u>Notices.</u>
                Written notices under this Agreement may be provided to HPE via the method provided in the Supporting Material.
                                                              </Paragraph>
              g.<u>Governing Law.</u>
              This Agreement will be governed by the laws of the state of California, U.S.A., excluding rules as to choice and conflict of law.
                                                                    You and HPE agree that the United Nations Convention on Contracts for the International Sale of Goods will not apply.
                                                              <Paragraph className="EULAPOPupSubtexts">
                h.<u>Force Majeure.</u>
                Neither party will be liable for performance delays nor for non-performance due to causes beyond its reasonable control,
                                                                    except for payment obligations.
                                                              </Paragraph>
              i.<u>Entire Agreement.</u>
              This Agreement represents our entire understanding with respect to its subject matter and supersedes any previous communication or
                                                                    agreements that may exist. Modifications to the Agreement will be made only through a written amendment signed by both parties.
                                                                    If HPE doesn't exercise its rights under this Agreement, such delay is not a waiver of its rights.
                                                    </Paragraph>
            <Paragraph margin="small">
              16.<b>Australian Consumers.</b>
              If you acquired the software as a consumer within the meaning of the 'Australian Consumer Law' under the Australian Competition
                                                            and Consumer Act 2010 (Cth) then despite any other provision of this Agreement, the terms at this URL apply:

                                                      <a href="http://www.hpe.com/software/SWLicensing" target="_blank">http://www.hpe.com/software/SWLicensing</a>
            </Paragraph>

            <Paragraph margin="small">
              17.<b>Russian Consumers.</b>
              If you are based in the Russian Federation and the rights to use the software are provided to you under a separate license and/or sublicense agreement concluded between you and a duly authorized HPE partner, then this Agreement shall not be applicable.
                                                    </Paragraph>

          </Box>

          <Footer pad={{ "vertical": "small" }} separator="top" align='center' textAlign='center' direction='row'>
            <Button label='Agree' primary={true} style={{ marginLeft: '35%' }} onClick={this.EULAInformationPopUpClose} />
            <Button label='Disagree' primary={true} style={{ marginLeft: '3%' }} onClick={this.DisagreeClicked} />
          </Footer>
        </Form>
      </Layer>
    }

    const layer = (
      <Layer className='LoadPopupLayer'>
        <LoadFiles title={this.state.LoadItemTitle}
          history={history}
          redirectTo={this.getNewRoute}
          onClose={this.closePopUps} />
      </Layer>
    );

    const notificationLayer = (
      <Layer className='LoadPopupLayerNotification'>
      <Notifications close={this.closeNotifications}/>
      </Layer>
    )

    var layerelement;
    if(this.state.LoadPopupScr)
    {
      layerelement = layer;
    }
    else if(this.props.showNotifications.enabled){
      layerelement = notificationLayer;
    }
    
        
    // <Paragraph style={{ margin: '2px 0px' }}>To allow solutions to be imported in one ConfigAdvanced, go to "Options" in the Main menu and enable "Show OCA buttons in Solution Alternatives"</Paragraph>
    if (this.state.About) {
      var AboutLoop;
      var aboutObject = this.state.HomePageJson.Sizers.Sizer.About.Para1;
      if (said === 'EPAvNext' && appUrl.toUpperCase().indexOf(HPECP_SIZER) !== -1) {
        aboutObject = this.state.HomePageJson.Sizers.Sizer.About.Para2
      }
      if (Array.isArray(aboutObject)) {
        AboutLoop = aboutObject.map(function (item) {
          return (
            <Paragraph style={{ margin: '2px 0px' }}>{item}</Paragraph>
          );
        });
      } else {
        AboutLoop = <Paragraph style={{ margin: '2px 0px' }}>{aboutObject}</Paragraph>
      }



      AboutHere = <Box margin="none" pad="none" direction="column" className="AboutContent" style={{ width: '45%', height: 'auto' }}>
        <Box margin="none" pad="none" >
          <Box margin="none" pad="none" align="center" className="triangle-up" style={{ margin: 'auto 88%' }}></Box>
        </Box>
        <Box margin="none" pad="none" style={{ backgroundColor: '#fff', borderBottom: '3px solid #01a982' }} className="ListItemAlign1">
          <Box direction="row" margin="none" pad="small" separator="bottom" style={{ backgroundColor: '#425563' }}>
            <Box direction="row" margin="none" pad="none" align='start' style={{ width: '96%' }}>
              <Heading tag="h4" style={{ marginBottom: '0px', color: '#fff' }}>{this.state.HomePageJson.Sizers.SizerCaption}</Heading>
            </Box>
            <Box direction="row" margin="none" pad="none" align='start' alignContent="start" onClick={this.closePopUps} >
              <CloseIcon size='small' className="CloseIconStyle" style={{ stroke: '#fff' }} />
            </Box>
          </Box>
          <Box margin="small" pad="none" align='start' style={{ margin: '2px 12px' }} >
            {AboutLoop}
          </Box>
          <Box direction="row" margin="none" pad="small" separator='top'>
            <Menu direction='row' size='small' dropAlign={{ "right": "right" }}>
              <Anchor style={{ cursor: 'Default' }}> Version {version} </Anchor>
              {/* <Anchor onClick={this.OtherSizersClick} className="OtherSizersHover" > Other Sizers </Anchor>
                              <Anchor href="https://www.hpe.com/us/en/privacy/ww-privacy-statement.html"
                                      target="_blank" style={{textDecoration:'none'}}>Privacy Policy</Anchor>   */}


              <Anchor id='mailTo' href={"mailto:ese_aa_solutions@hpe.com?Subject=" + encodeURI(this.state.HomePageJson.Sizers.SizerCaption) + "%20(Online%20Client)%20-%20v%20" + version} style={{ textDecoration: "underline" }}> Contact </Anchor>
            </Menu>
          </Box>
        </Box>
      </Box>
    } else {
      AboutHere = "";
    }
    if (this.state.UserGuide) {
      UserGuideHere = <Box margin="none" pad="none" direction="column" style={{ width: '28%', height: 'auto', position: "absolute", top: "175px", right: "27%", transition: "0.5s ease-in-out" }}>
        <Box margin="none" pad="none" >
          <Box margin="none" pad="none" align="center" className="triangle-up" style={{ margin: 'auto 88%' }}></Box>
        </Box>
        <Box margin="none" pad="none" style={{ backgroundColor: '#fff', borderBottom: '3px solid #01a982' }} className="ListItemAlign1">
          <Box direction="row" margin="none" pad="small" separator="bottom" style={{ backgroundColor: '#425563' }}>
            <Box direction="row" margin="none" pad="none" align='start' style={{ width: '96%' }}>
              <Heading tag="h4" style={{ marginBottom: '0px', color: '#fff' }}>UserGuide</Heading>
            </Box>
            <Box direction="row" margin="none" pad="none" align='start' alignContent="start" onClick={this.closePopUps} >
              <CloseIcon size='small' className="CloseIconStyle" style={{ stroke: '#fff' }} />
            </Box>
          </Box>
          <Box margin="none" pad="small" separator='top'>
              {said === 'EPAvNext' ? 
                <Menu size='small' dropAlign={{ "right": "right" }}>
                  <Anchor href={appUrl + '/Docs/EPA BigData Sizer Online - User Guide.pdf'} target='_blank' icon={<DownloadImg colorIndex="accent-3" size="small" />} style={{ textDecoration: "underline" }}>User Guide to EPA BigData Solution</Anchor>
                  <Anchor href={appUrl + '/Docs/EPA HPE Container Platform Sizer Online - User Guide.pdf'} target='_blank' icon={<DownloadImg colorIndex="accent-3" size="small" />} style={{ textDecoration: "underline" }}>User Guide to EPA HPE Container Platform Solution</Anchor>
                </Menu>
              : ''}
              {said === 'SAPHANA' ?
                <Menu size='small' dropAlign={{ "right": "right" }}>
                  <Anchor href={appUrl + 'Docs/User Guide to SAP Appliance Solution.pdf'} target='_blank' icon={<DownloadImg colorIndex="accent-3" size="small" />} style={{ textDecoration: "underline" }}>User Guide to SAP Appliance Solution</Anchor>
                  <Anchor href={appUrl + 'Docs/User Guide to SAP TDI Solution.pdf'} target='_blank' icon={<DownloadImg colorIndex="accent-3" size="small" />} style={{ textDecoration: "underline" }}>User Guide to SAP TDI Solution</Anchor>
                </Menu>
              : ''}
          </Box>
        </Box>
      </Box>
    } else {
      UserGuideHere = "";
    }
    if (this.state.AdditionalInfoPop) {
      if (Array.isArray(this.state.HomePageJson.Sizers.Sizer.AdditionalInformation.Doc)) {
        AdditionalList = this.state.HomePageJson.Sizers.Sizer.AdditionalInformation.Doc.map(function (val, id) {
          // <td> {val["Name"]}  </td>
          return (
            <TableRow key={id.toString()}>
              <td className='secondary' > <Anchor style={{ cursor: 'pointer' }} onClick={() => window.open(decodeURIComponent(val["Url"]))} >  {val["Name"]}  </Anchor></td>
            </TableRow>
          );
        });
      } else {
        AdditionalList = <TableRow >
          <td className='secondary'  > <Anchor style={{ cursor: 'pointer' }} onClick={() => window.open(decodeURIComponent(this.state.HomePageJson.Sizers.Sizer.AdditionalInformation.Doc['Url']))} >  {this.state.HomePageJson.Sizers.Sizer.AdditionalInformation.Doc["Name"]}  </Anchor></td>
        </TableRow>

      }

      AdditionalInformation = <Layer className="AdditionalInflolayer" style={{ width: '50%', height: '50%' }}>
        <Box direction="column" margin="none" pad="none">
          <Box direction="row" colorIndex="neutral-1" margin="none" pad="small" separator="bottom">
            <Box direction="row" margin="none" pad="none" align='start' style={{ width: '96%' }}>
              <Heading tag="h4" strong={true} style={{ marginBottom: '0px', color: '#01a982' }}>Additional Information</Heading>
            </Box>
            <Box direction="row" margin="none" pad="none" align='start' alignContent="start" onClick={this.closePopUps} >
              <CloseIcon size='small' colorIndex="light-2" className="CloseIconStyle" />
            </Box>
          </Box>
          <Box margin="none" pad="small">
            <Heading tag="h6" strong={true} style={{ margin: '4px 0px' }}>Learn More</Heading>
            <Paragraph style={{ margin: '2px 0px', maxWidth: '100%' }}>{this.state.HomePageJson.Sizers.Sizer.AdditionalInformation["@Text"]}</Paragraph>
            <Table style={{ margin: '4px 0px', overflow: 'initial' }} selectable={false}>
              <tbody>
                {AdditionalList}
              </tbody>
            </Table>
          </Box>
        </Box>
      </Layer>
    } else {
      AdditionalInformation = "";
    }

    if (this.state.whatsNew) {



      WhatsnewHere = <WhatsNewPage click={this.WhatsNewParent} />
    } else {
      WhatsnewHere = "";
    }

    if (this.state.userDetailsPop) {
      UserDetailsRender = <UserDetailsPage onLogOut={this.props.onLogout} userDetails={this.props.userData} click={this.WhatsNewParent} />
    } else {
      UserDetailsRender = "";
    }

    if (this.state.HowTo) {
      HowToHere = <Box margin="none" pad="none" direction="column" className="HOwTOContent" style={{ width: '13%', height: 'auto' }}>
        <Box margin="none" pad="none" >
          <Box margin="none" pad="none" align="center" className="triangle-up" style={{ margin: 'auto' }}></Box>
        </Box>
        <Box margin="none" pad="none" style={{ backgroundColor: '#fff' }} className="ListItemAlign">
          <Box margin="none" pad="none" align='end' onClick={this.closePopUps} >
            <CloseIcon size='small' className="CloseIconStyle" />
          </Box>
          <List>
            <ListItem justify='between'> <span> How To </span> </ListItem>
            <ListItem justify='between'> <span> Eric </span> </ListItem>
          </List>
        </Box>
      </Box>
    } else {
      HowToHere = "";
    }
    // var MainApp={maxWidth: '100%' }

    var showDelSession;
    var showUpdateSession;

    if (this.state.showUpdateSession) {
      showUpdateSession = <Layer>
        <Box margin='none' pad='none' size='medium' justify='between' >
          <Box direction="row" colorIndex="neutral-1" margin="none" style={{ padding: '12px 12px 0px 12px' }} separator="bottom">
            <Box direction="row" margin="none" pad={{ between: 'small' }} align='start' style={{ width: '96%' }}>
              <Heading tag="h4" strong={false} >Update Session</Heading>
            </Box>
            <Box direction="row" margin="none" pad="none" align='start' alignContent="start" onClick={this.CloseDelSession} >
              <CloseIcon size='small' colorIndex="light-2" className="CloseIconStyle" />
            </Box>
          </Box>
          <Box direction="row" margin="none" pad="small" justify="start" style={{ width: '100%' }} >
            <TextInput value={this.state.SessionNameTxt} style={{ width: '80%' }}
              placeHolder='Session Name'
              onDOMChange={this.SessionTxtChange} />
            {this.state.SessionNameTxt === '' || this.state.SessionNameTxt.trim() === '' ?
              <Button primary={true} icon={<FormNextLink size='small' />} />
              :
              <Button primary={true} icon={<FormNextLink size='small' />}
                onClick={this.Submit_Update_Session} />
            }
          </Box>
        </Box>
      </Layer>
    } else {
      showUpdateSession = ""
    }

    if (this.state.showDelSession) {
      showDelSession = <Layer>
        <Box margin='none' pad='none' size='medium' >
          <Box direction="row" colorIndex="neutral-1" margin="none" style={{ padding: '12px 12px 0px 12px' }} separator="bottom">
            <Box direction="row" margin="none" pad={{ between: 'small' }} align='start' style={{ width: '96%' }}>
              <WarningIcon size='small' colorIndex='warning' />
              <Heading tag="h4" strong={false} >Please Confirm</Heading>
            </Box>
            <Box direction="row" margin="none" pad="none" align='start' alignContent="start"  >
              <CloseIcon size='small' colorIndex="light-2" className="CloseIconStyle" onClick={this.CloseDelSession} />
            </Box>
          </Box>
          <Box margin="none" pad="small">
            <Heading tag='h6' strong={false} margin='none'>
              Are you sure you want to delete the selected session:
                                         </Heading>
            <Heading tag='h6' strong={true} margin='none'>
              {this.state.DelSession.alias}
            </Heading>
          </Box>
          <Box direction='row' justify='end' margin='none' pad='small'>
            <Button label='Yes' className="SessionOutBtns" onClick={() => this.Submit_Delete_Session(this.state.DelSession.id)} />
            <Button label='No' className="SessionOutBtns" critical={true} onClick={this.CloseDelSession} />
          </Box>
        </Box>
      </Layer>
    } else {
      showDelSession = ""
    }

    var sessionsMenu = "";

    if (this.props.allSessions.length > 0) {

      var s = this.props.allSessions.map((val) => {
        return (

          <TableRow key={val.id}>
            <td> <Anchor pad='none' margin='small' className="UserSelectionAnchor" style={{ width: '245px', margin: '0px 0px', fontWeight: '500' }}
              onClick={() => this.Submit_Change_Session(val.id)}>
              {val.alias}
            </Anchor></td>
            <td>  <Button primary={false} plain={true} onClick={() => this.setState({ SessionName: val, SessionNameTxt: val.alias, showUpdateSession: true, showAddSession: false })}
              icon={<FormEdit size="small" colorIndex='#ff9374' />} /> </td>
            <td>   <Button primary={false} plain={true} onClick={() => this.ShowDelSession(val)}
              // onClick ={ ()=>this.props.onDeleteSession(val.id) }
              icon={<TrashIcon size="small" colorIndex='#ff9374' />} /> </td>
          </TableRow>


        )
      });

      //  var s = this.props.allSessions.map((val) => {
      //     return(<ListItem key={val.id} pad='none' >
      //                      <Box direction="row" margin='none' pad='none' >
      //                          <Anchor pad='none' margin='small' style={{margin:'12px 0px', fontWeight: '500'}}
      //                                  onClick={() => this.Submit_Change_Session(val.id) }>
      //                                  {val.alias}
      //                          </Anchor>
      //                          <Box direction="row" margin='none' pad='none' align='end'>
      //                             <Button primary={false} plain={true} onClick = { () => this.setState({ SessionName: val, SessionNameTxt: val.alias, showUpdateSession: true }) }
      //                                     icon={<FormEdit size="small" colorIndex='#ff9374' />}  />
      //                             <Button primary={false} plain={true} onClick ={ () => this.ShowDelSession(val) }
      //                                     // onClick ={ ()=>this.props.onDeleteSession(val.id) }
      //                                     icon={<TrashIcon size="small" colorIndex='#ff9374' />}  />
      //                          </Box>
      //                      </Box>
      //            </ListItem>
      //     )
      // });
    }

    if (this.props.allSessions.length > 0) {
      sessionsMenu = <Menu responsive={true} closeOnClick={true} size='medium' margin='none'
        icon={<User size="small" colorIndex='accent-3' />}
        label='Organize' className="OrganiseMenu">
        {s}
      </Menu>
    }

    var CountryChangeAlert = "";
    if (this.state.ShowCountryChangeAlert) {
      CountryChangeAlert = <Layer>
        <Box margin='none' pad='none' size='medium' >
          <Box direction="row" colorIndex='neutral-1' margin="none" style={{ padding: '12px 12px 0px 12px' }} separator="bottom">
            <Box direction="row" margin="none" pad={{ between: 'small' }} align='start' style={{ width: '96%' }}>
              <WarningIcon size='small' colorIndex='warning' />
              <Heading tag="h4" strong={false} >Notification</Heading>
            </Box>
          </Box>
          <Box margin="none" pad="small">
            <Heading tag='h6' strong={false} margin='none'>
              Change in country is observed, you should resize the workload to get the updated country price details in solution summary.
                                         </Heading>
          </Box>
          <Box direction='row' justify='end' margin='none' style={{ padding: '0px 12px 12px 0px' }}>
            <Button label='Ok' className="SessionOutBtns"
              onClick={() => {
                this.state.ShowCountryChangeAlert = false;
                this.props.history.push('/Build/SolnAlternative')
              }
              } />
          </Box>
        </Box>
      </Layer>
    }
    let ReferenceArchitectureDisplay;

    if (this.state.referenceArchitectureState) {
      if (said === "EPAvNext") {
        ReferenceArchitectureDisplay = <ReferenceComponent click={this.closePopUps} history={history} redirectTo={this.getNewRoute} />
      }
      else {
        ReferenceArchitectureDisplay = <AdditionalReferenceComponent click={this.closePopUps} history={history} redirectTo={this.getNewRoute} />
      }
    } else {
      ReferenceArchitectureDisplay = ""
    }
    var lookuplayer = "";
    if (said === "SAP" || said === "SAPHANA") {
      if (this.state.SAPLookuplayer === true) {
        lookuplayer = <Layer className="SAPLookuplayer" style={{ overflow: "hidden" }}>
          <SAPLOOKUP onClose={this.closePopUps} />
        </Layer>
      }

    }


    return (
      <Box margin="none" pad="none" className="HomeScreen">
        {EULAInformationPopUp}
        {DisagreeScreen}
        {AdditionalInformation}
        {ReferenceArchitectureDisplay}

        {layerelement}
        {showDelSession}
        {showUpdateSession}
        {CountryChangeAlert}
        {lookuplayer}
        {hideforSSET==='True'?'':
        <Box margin="none" pad="none" className="AppbackGroundImage" >
          <Box margin="none" pad="none" className="AppbackGround" >
          <Box style={{width:'82%',alignSelf:'center'}}>
            <Box margin="none" pad="small" style={{ width: '100%', borderBottom: '1px solid #425563', padding: '6px' }}> <Heading tag='h3' strong={true} style={{ textAlign: 'center', color: '#fff', fontSize: '27px', margin: '0px' }}>{SizerCaption}</Heading></Box>
            <Box pad="none" margin="none" style={{ width: '100%', height: '100%' }}>
              <Box margin="none" pad="none" style={{ width: '100%', height: '100%', }}>
                <Box margin="none" pad="none" style={{ width: '100%', height: '100%' }}>
                  <Box direction="row" pad="none" justify="between" margin="none"
                    style={{ width: '100%' }}>
                    <Box direction="row" pad="none" justify="between" margin="none">
                      <Label margin="none" className="WeightFontColor">Pricing Region</Label>
                      <Menu justify="start" icon={<Map size="small" colorIndex='accent-3' />} align="start" className="PricelistButton WeightFontColor" responsive={true} inline={false} label={this.props.country} size='small' primary={false} pad='none'>
                        {CountyList}
                      </Menu>
                      {sessionsMenu}
                    </Box>
                    <Menu dropAlign={{ "right": "right" }} direction="row" className="MenuBarList">


                      {userDetails}
		      {said === 'SAPHANA' ? <Anchor className='active WeightFontColor' onClick={this.UserGuideClick} label='User Guide' icon={<DownloadImg colorIndex="accent-3" size="small" />} />
                        :
                        <Anchor className='active WeightFontColor' href={appUrl + '/Docs/' + docName + UserGuide +'.pdf'} target='_blank' label='User Guide' icon={<DownloadImg colorIndex="accent-3" size="small" />} />
		      }

                      {whatsnewButton}
                      {/*<Anchor className='active WeightFontColor' onClick={this.HowToClick}  label='How To' icon={ <WorkshopIcon colorIndex="#ff8d6d" size="small"/>}/>*/}
                      <Anchor className='active WeightFontColor' onClick={this.AboutClick} label='About' icon={<Catalog colorIndex="accent-3" size="small" />} />
                    </Menu>
                  </Box>
                  {UserGuideHere}
                  {AboutHere}
                  {WhatsnewHere}
                  {HowToHere}
                  {said==='SynergySizer'?'':Textcontent}
                  {UserDetailsRender}
                  <Box id='OptionsSection' style={{ width: '100%', height: '100%' }} justify='start' align='center' wrap={false} pad='none' margin='none'>
                    <Box direction="row" wrap={true} margin="none" pad="none" justify="center" style={{ width: '100%' }}>
                      {EPASizingHomeMenuItems}
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
          </Box>
        </Box>}  
        { /* <CustomFooter  /> */}
      </Box>
    );
  }
}

const mapStateToProps = (state) => {
  let secondTemplate ;
  if(said==='EPAvNext')
  {
    secondTemplate = state.sessions.sessionDefaults.blueDataWorkload;
  }else if(said==='SAPHANA')
  {
    secondTemplate = state.sessions.sessionDefaults.tdiWorkload;
  }
  let Country = state.sessions.Country;
  try{
if(state.sessions.activeSession!== undefined && state.sessions.activeSession.workload.UserInputs.Country!==undefined)
     Country = state.sessions.activeSession.workload.UserInputs.Country;
  }catch(e){}
  return {
    allSessions: state.sessions.sessions,
    activeSession: state.sessions.activeSession,
    userData: state.auth.userData,
    DefaultInputs: state.sessions.sessionDefaults.inputs,
    WhatsNewContent: state.sessions.sessionDefaults.whatsNew,
    countries: state.sessions.sessionDefaults.Countries,
    country: Country,
    EULAInformation: state.sessions.EULAPopUpState,
    sizerWorkLoad: state.sizerWorkload.workload,
    workloadTemplate: state.sessions.sessionDefaults.workload,
    sessionDefaults: state.sizerWorkload.sessionDefaults,
    sset: state.sizerWorkload.SSETloaded,
    guiState: state.sizerWorkload.guiState,
    blueDataworkloadTemplate:secondTemplate,
    notifications:state.sessions.notifications,
    showNotifications:state.sessions.showNotifications,
    sessionsState:state.sessions,
    LookupServers: state.sizerWorkload.lookupservers,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onSaveCurrentSession: () => {
      dispatch(SaveCurrentSession());
    },
    onLogout: () => {
      dispatch(logOut());
    },
    onAddSession: (id, name) => {
      dispatch(addSession(id, name));
    },
    onChangeSession: (id) => {
      dispatch(changeSession(id));
    },
    onDeleteSession: (id) => {
      dispatch(deleteSession(id));
    },
    onUpdateSession: (session) => {
      dispatch(updateSession(session))
    },
    onCountryChange: (country) => {
      dispatch(updateCountry(country))
    },
    onUpdateEULA: (data) => {
      dispatch(updateEULA(data))
    },
    onLoadSessionfromSSET: (data) => {
      dispatch(loadSessionfromSSET(data))
    },
    onLoadNotifications:(data)=>{
      dispatch(loadNotifications(data));
    },
    onNewSession: (workload) => {
      dispatch({ type: 'UPDATE_SIZER_WORKLOAD', payload: workload })
    },
    onInsertSessionDefaults: (inputs) => {
      dispatch({ type: 'UPDATE_SESSION_DEFAULTS', payload: inputs })
    },
    onUpdateActiveSession: (workload) => {
      dispatch({ type: 'UPDATE_Active_WORKLOAD', payload: workload })
    },
    onUpdateDefaultSession: (inputs) => {
      dispatch({ type: 'UPDATE_SESSION_DEFAULTS', payload: inputs })
    },
    updateSSETId: (inputs) => {
      dispatch({ type: 'UPDATE_SSETID', payload: inputs })
    },
    GetWorkloadWithMainstream: (value) => {
      dispatch(GetWorkloadWithMainstream(value));
    },
    OnFetchLookupServersList: (value) => {
      dispatch(fetchLookupServersList(value));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MyMain);



// WEBPACK FOOTER //
// ./src/SizingEngineUI/SizingEngineCommonScreens/Home.js